//import React, { useEffect, useState } from "react";
//import { useSelector } from "react-redux";
//import { FaRegSmile } from "react-icons/fa";
//import { TfiFaceSad } from "react-icons/tfi";
//import { FaRegFaceMeh } from "react-icons/fa6";
//import useAxiosInstance from "../../../services/useAxiosInstance";

//const ServiceRequestRange = () => {
//    const axiosInstance = useAxiosInstance();
//    const [activeButton, setActiveButton] = useState("Annually");
//    const [serviceRequestData, setServiceRequestData] = useState({
//        pending: 0,
//        canceled: 0,
//        workDone: 0,
//        vendorAssigned: 0,
//        total: 0,
//    });

//    const [localStartDate, setLocalStartDate] = useState("");
//    const [localEndDate, setLocalEndDate] = useState("");
//    const roleId = useSelector((state) => state.auth.roleId);

//    const { communityId } = useSelector((state) => state.auth);
//    const clientIds = useSelector((state) => state.auth.clientId);

//    let clientIdget;
//    if (roleId === 1001 || roleId === 1002) {
//        clientIdget = 0;
//    } else if (roleId === 1003) {
//        clientIdget = clientIds;
//    }

//    const formatDate = (date) => {
//        const year = date.getFullYear();
//        const month = String(date.getMonth() + 1).padStart(2, '0');
//        const day = String(date.getDate()).padStart(2, '0');
//        return `${year}-${month}-${day}`;
//    };

//    const fetchServiceRequestData = async () => {
//        try {
//            if (!localStartDate || !localEndDate) return;

//            const response = await axiosInstance.get(
//                `/api/public/servicerequest/admin/getAllServiceRequests`,
//                {
//                    params: {
//                        communityId: communityId,
//                        requestedClientId: clientIdget,
//                        startDate: localStartDate,
//                        endDate: localEndDate
//                    },
//                }
//            );

//            const data = response.data;
//            console.log("API Response:", data);

//            setServiceRequestData({
//                pending: data.pending || 0,
//                canceled: data.canceled || 0,
//                workDone: data.workDone || 0,
//                vendorAssigned: data.vendorAssigned || 0,
//                total: (data.pending || 0) + (data.canceled || 0) + (data.workDone || 0) + (data.vendorAssigned || 0)
//            });
//        } catch (error) {
//            console.error("Error fetching service request data:", error);
//        }
//    };

//    const handleButtonClick = (buttonName) => {
//        setActiveButton(buttonName);

//        const currentDate = new Date();
//        let newStartDate = "";
//        let newEndDate = formatDate(currentDate);

//        switch (buttonName) {
//            case "Daily":
//                newStartDate = newEndDate;
//                break;

//            case "Weekly":
//                const startOfWeekDays = new Date(currentDate);
//                startOfWeekDays.setDate(currentDate.getDate() - 6);
//                if (startOfWeekDays.getMonth() !== currentDate.getMonth()) {
//                    startOfWeekDays.setDate(1);
//                }
//                newStartDate = formatDate(startOfWeekDays);
//                break;

//            case "Annually":
//                const startOfYear = new Date(currentDate);
//                if (currentDate.getMonth() === 1 && currentDate.getDate() === 29) {
//                    startOfYear.setDate(28);
//                }
//                startOfYear.setFullYear(currentDate.getFullYear() - 1);
//                newStartDate = formatDate(startOfYear);
//                break;

//            default:
//                break;
//        }

//        console.log(`Date range selected: ${newStartDate} to ${newEndDate}`);
//        setLocalStartDate(newStartDate);
//        setLocalEndDate(newEndDate);
//    };

//    useEffect(() => {
//        handleButtonClick("Annually");
//    }, []);

//    useEffect(() => {
//        fetchServiceRequestData();
//    }, [communityId, localStartDate, localEndDate, clientIdget]);

//    const getWidthPercentage = (value) => {
//        if (!serviceRequestData.total) return 0;
//        return (value / serviceRequestData.total) * 100;
//    };

//    return (
//        <div>
//            <div className="items-center p-2.5 border-b border-gray-100 sm:flex sm:justify-between md:flex lg:flex">
//                <div>
//                    <p className="m-0 text-sm text-gray-500">Community</p>
//                    <h2 className="m-0 text-2xl text-gray-800">Service Request</h2>
//                </div>
//                <div>
//                    <div className="flex justify-between sm:block md:block lg:block">
//                        <button
//                            className={`mt-1 bg-gray-200 text-black border-none py-2.5 px-5 ml-2.5 cursor-pointer rounded transition-colors ${activeButton === "Daily" ? "bg-black text-white" : ""
//                                }`}
//                            onClick={() => handleButtonClick("Daily")}
//                        >
//                            Daily
//                        </button>
//                        <button
//                            className={`mt-1 bg-gray-200 text-black border-none py-2.5 px-5 ml-2.5 cursor-pointer rounded transition-colors ${activeButton === "Weekly" ? "bg-black text-white" : ""
//                                }`}
//                            onClick={() => handleButtonClick("Weekly")}
//                        >
//                            Weekly
//                        </button>
//                        <button
//                            className={`mt-1 bg-gray-200 text-black border-none py-2.5 px-5 ml-2.5 cursor-pointer rounded transition-colors ${activeButton === "Annually" ? "bg-black text-white" : ""
//                                }`}
//                            onClick={() => handleButtonClick("Annually")}
//                        >
//                            Annually
//                        </button>
//                    </div>
//                </div>
//            </div>
//            <div className="p-5">
//                <div className="w-full h-9 bg-white rounded my-5 flex overflow-hidden" style={{ border: "1px solid #ccc" }}>
//                    {/* Pending - Yellow */}
//                    <div
//                        className="h-full"
//                        style={{
//                            width: `${getWidthPercentage(serviceRequestData.pending)}%`,
//                            backgroundColor: "#FFC107",
//                        }}
//                        title={`Pending: ${serviceRequestData.pending}`}
//                    ></div>

//                    {/* Canceled - Red */}
//                    <div
//                        className="h-full"
//                        style={{
//                            width: `${getWidthPercentage(serviceRequestData.canceled)}%`,
//                            backgroundColor: "#F44336",
//                        }}
//                        title={`Canceled: ${serviceRequestData.canceled}`}
//                    ></div>

//                    {/* Work Done - Green */}
//                    <div
//                        className="h-full"
//                        style={{
//                            width: `${getWidthPercentage(serviceRequestData.workDone)}%`,
//                            backgroundColor: "#4CAF50",
//                        }}
//                        title={`Work Done: ${serviceRequestData.workDone}`}
//                    ></div>

//                    {/* Vendor Assigned - Blue */}
//                    <div
//                        className="h-full"
//                        style={{
//                            width: `${getWidthPercentage(serviceRequestData.vendorAssigned)}%`,
//                            backgroundColor: "#2196F3",
//                        }}
//                        title={`Vendor Assigned: ${serviceRequestData.vendorAssigned}`}
//                    ></div>
//                </div>

//                <div className="flex gap-8">
//                    <div>
//                        <p className="m-0 text-sm text-gray-600">Pending</p>
//                        <span className="text-lg font-bold text-gray-800 flex gap-4">
//                            <span className="text-yellow-500"><FaRegFaceMeh /></span>
//                            {serviceRequestData.pending || 0}
//                        </span>
//                    </div>
//                    <div>
//                        <p className="m-0 text-sm text-gray-600">Canceled</p>
//                        <span className="text-lg font-bold text-gray-800 flex gap-4">
//                            <span className="text-red-500"><TfiFaceSad /></span>
//                            {serviceRequestData.canceled || 0}
//                        </span>
//                    </div>
//                    <div>
//                        <p className="m-0 text-sm text-gray-600">Work Done</p>
//                        <span className="text-lg font-bold text-gray-800 flex gap-4">
//                            <span className="text-green-500"><FaRegSmile /></span>
//                            {serviceRequestData.workDone || 0}
//                        </span>
//                    </div>
//                    <div>
//                        <p className="m-0 text-sm text-gray-600">Vendor Assigned</p>
//                        <span className="text-lg font-bold text-gray-800 flex gap-4">
//                            <span className="text-blue-500"><FaRegSmile /></span>
//                            {serviceRequestData.vendorAssigned || 0}
//                        </span>
//                    </div>
//                </div>
//            </div>
//        </div>
//    );
//};

//export default ServiceRequestRange;

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FaRegSmile } from "react-icons/fa";
import { TfiFaceSad } from "react-icons/tfi";
import { FaRegFaceMeh } from "react-icons/fa6";
import useAxiosInstance from "../../../services/useAxiosInstance";

const ServiceRequestRange = ({ startDate, endDate }) => {
    const axiosInstance = useAxiosInstance();
    const [activeButton, setActiveButton] = useState("Annually");
    const [serviceRequestData, setServiceRequestData] = useState({
        pending: 0,
        canceled: 0,
        workDone: 0,
        vendorAssigned: 0,
        total: 0,
    });

    const [localStartDate, setLocalStartDate] = useState("");
    const [localEndDate, setLocalEndDate] = useState("");
    const [loading, setLoading] = useState(false);

    const roleId = useSelector((state) => state.auth.roleId);
    const { communityId } = useSelector((state) => state.auth);
    const clientIds = useSelector((state) => state.auth.clientId);

    // Role-based parameter configuration
    const getApiParameters = () => {
        let communityIdParam, clientIdParam;

        switch (roleId) {
            case 1000: // Superadmin - All communities
                communityIdParam = 0;
                clientIdParam = 0;
                break;
            case 1001: // HOA Admin - Specific community, all clients
            case 1002: // Board Member - Specific community, all clients
                communityIdParam = communityId;
                clientIdParam = 0;
                break;
            case 1003: // User - Specific community and client
                communityIdParam = communityId;
                clientIdParam = clientIds;
                break;
            default:
                communityIdParam = communityId;
                clientIdParam = 0;
        }

        return { communityIdParam, clientIdParam };
    };

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const fetchServiceRequestData = async () => {
        if (!localStartDate || !localEndDate) return;

        setLoading(true);

        try {
            const { communityIdParam, clientIdParam } = getApiParameters();

            const response = await axiosInstance.get(
                `/api/public/servicerequest/admin/getAllServiceRequests`,
                {
                    params: {
                        communityId: communityIdParam,
                        requestedClientId: clientIdParam,
                        startDate: localStartDate,
                        endDate: localEndDate
                    },
                }
            );

            const data = response.data;
            console.log("API Response:", data);

            setServiceRequestData({
                pending: data.pending || 0,
                canceled: data.canceled || 0,
                workDone: data.workDone || 0,
                vendorAssigned: data.vendorAssigned || 0,
                total: (data.pending || 0) + (data.canceled || 0) + (data.workDone || 0) + (data.vendorAssigned || 0)
            });
        } catch (error) {
            console.error("Error fetching service request data:", error);

            // Fallback data based on role
            const fallbackData = getFallbackData();
            setServiceRequestData(fallbackData);
        } finally {
            setLoading(false);
        }
    };

    // Role-based fallback data
    const getFallbackData = () => {
        switch (roleId) {
            case 1000: // Superadmin - Higher numbers
                return {
                    pending: 45,
                    canceled: 12,
                    workDone: 89,
                    vendorAssigned: 34,
                    total: 180
                };
            case 1001:
            case 1002: // HOA roles - Medium numbers
                return {
                    pending: 8,
                    canceled: 3,
                    workDone: 15,
                    vendorAssigned: 6,
                    total: 32
                };
            default:
                return {
                    pending: 2,
                    canceled: 1,
                    workDone: 5,
                    vendorAssigned: 1,
                    total: 9
                };
        }
    };

    const handleButtonClick = (buttonName) => {
        setActiveButton(buttonName);

        const currentDate = new Date();
        let newStartDate = "";
        let newEndDate = formatDate(currentDate);

        switch (buttonName) {
            case "Daily":
                newStartDate = newEndDate;
                break;

            case "Weekly":
                const startOfWeekDays = new Date(currentDate);
                startOfWeekDays.setDate(currentDate.getDate() - 6);
                if (startOfWeekDays.getMonth() !== currentDate.getMonth()) {
                    startOfWeekDays.setDate(1);
                }
                newStartDate = formatDate(startOfWeekDays);
                break;

            case "Annually":
                const startOfYear = new Date(currentDate);
                if (currentDate.getMonth() === 1 && currentDate.getDate() === 29) {
                    startOfYear.setDate(28);
                }
                startOfYear.setFullYear(currentDate.getFullYear() - 1);
                newStartDate = formatDate(startOfYear);
                break;

            default:
                break;
        }

        console.log(`Date range selected: ${newStartDate} to ${newEndDate}`);
        setLocalStartDate(newStartDate);
        setLocalEndDate(newEndDate);
    };

    useEffect(() => {
        handleButtonClick("Annually");
    }, []);

    useEffect(() => {
        fetchServiceRequestData();
    }, [communityId, localStartDate, localEndDate, roleId, clientIds]);

    const getWidthPercentage = (value) => {
        if (!serviceRequestData.total) return 0;
        return (value / serviceRequestData.total) * 100;
    };

    // Role-based title and description
    const getHeaderInfo = () => {
        switch (roleId) {
            case 1000:
                return {
                    title: "Service Requests - System Overview",
                    description: "All communities"
                };
            case 1001:
            case 1002:
                return {
                    title: "Service Requests - Community",
                    description: "Your community"
                };
            default:
                return {
                    title: "Service Requests",
                    description: "Community"
                };
        }
    };

    const headerInfo = getHeaderInfo();

    return (
        <div>
            <div className="items-center p-2.5 border-b border-gray-100 sm:flex sm:justify-between md:flex lg:flex">
                <div>
                    <p className="m-0 text-sm text-gray-500">{headerInfo.description}</p>
                    <h2 className="m-0 text-2xl text-gray-800">{headerInfo.title}</h2>
                    {loading && <p className="text-xs text-blue-500 mt-1">Loading data...</p>}
                </div>
                <div>
                    <div className="flex justify-between sm:block md:block lg:block">
                        <button
                            className={`mt-1 bg-gray-200 text-black border-none py-2.5 px-5 ml-2.5 cursor-pointer rounded transition-colors ${activeButton === "Daily" ? "bg-black text-white" : ""
                                }`}
                            onClick={() => handleButtonClick("Daily")}
                        >
                            Daily
                        </button>
                        <button
                            className={`mt-1 bg-gray-200 text-black border-none py-2.5 px-5 ml-2.5 cursor-pointer rounded transition-colors ${activeButton === "Weekly" ? "bg-black text-white" : ""
                                }`}
                            onClick={() => handleButtonClick("Weekly")}
                        >
                            Weekly
                        </button>
                        <button
                            className={`mt-1 bg-gray-200 text-black border-none py-2.5 px-5 ml-2.5 cursor-pointer rounded transition-colors ${activeButton === "Annually" ? "bg-black text-white" : ""
                                }`}
                            onClick={() => handleButtonClick("Annually")}
                        >
                            Annually
                        </button>
                    </div>
                </div>
            </div>
            <div className="p-5">
                {/* Progress Bar */}
                <div className="w-full h-9 bg-white rounded my-5 flex overflow-hidden" style={{ border: "1px solid #ccc" }}>
                    {/* Pending - Yellow */}
                    <div
                        className="h-full transition-all duration-500 ease-in-out"
                        style={{
                            width: `${getWidthPercentage(serviceRequestData.pending)}%`,
                            backgroundColor: "#FFC107",
                        }}
                        title={`Pending: ${serviceRequestData.pending}`}
                    ></div>

                    {/* Canceled - Red */}
                    <div
                        className="h-full transition-all duration-500 ease-in-out"
                        style={{
                            width: `${getWidthPercentage(serviceRequestData.canceled)}%`,
                            backgroundColor: "#F44336",
                        }}
                        title={`Canceled: ${serviceRequestData.canceled}`}
                    ></div>

                    {/* Work Done - Green */}
                    <div
                        className="h-full transition-all duration-500 ease-in-out"
                        style={{
                            width: `${getWidthPercentage(serviceRequestData.workDone)}%`,
                            backgroundColor: "#4CAF50",
                        }}
                        title={`Work Done: ${serviceRequestData.workDone}`}
                    ></div>

                    {/* Vendor Assigned - Blue */}
                    <div
                        className="h-full transition-all duration-500 ease-in-out"
                        style={{
                            width: `${getWidthPercentage(serviceRequestData.vendorAssigned)}%`,
                            backgroundColor: "#2196F3",
                        }}
                        title={`Vendor Assigned: ${serviceRequestData.vendorAssigned}`}
                    ></div>
                </div>

                {/* Statistics Grid */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="text-center">
                        <p className="m-0 text-sm text-gray-600">Pending</p>
                        <span className="text-lg font-bold text-gray-800 flex items-center justify-center gap-2">
                            <span className="text-yellow-500"><FaRegFaceMeh /></span>
                            {serviceRequestData.pending || 0}
                        </span>
                        <div className="text-xs text-gray-500 mt-1">
                            {serviceRequestData.total > 0
                                ? `${((serviceRequestData.pending / serviceRequestData.total) * 100).toFixed(1)}%`
                                : '0%'
                            }
                        </div>
                    </div>

                    <div className="text-center">
                        <p className="m-0 text-sm text-gray-600">Canceled</p>
                        <span className="text-lg font-bold text-gray-800 flex items-center justify-center gap-2">
                            <span className="text-red-500"><TfiFaceSad /></span>
                            {serviceRequestData.canceled || 0}
                        </span>
                        <div className="text-xs text-gray-500 mt-1">
                            {serviceRequestData.total > 0
                                ? `${((serviceRequestData.canceled / serviceRequestData.total) * 100).toFixed(1)}%`
                                : '0%'
                            }
                        </div>
                    </div>

                    <div className="text-center">
                        <p className="m-0 text-sm text-gray-600">Work Done</p>
                        <span className="text-lg font-bold text-gray-800 flex items-center justify-center gap-2">
                            <span className="text-green-500"><FaRegSmile /></span>
                            {serviceRequestData.workDone || 0}
                        </span>
                        <div className="text-xs text-gray-500 mt-1">
                            {serviceRequestData.total > 0
                                ? `${((serviceRequestData.workDone / serviceRequestData.total) * 100).toFixed(1)}%`
                                : '0%'
                            }
                        </div>
                    </div>

                    <div className="text-center">
                        <p className="m-0 text-sm text-gray-600">Vendor Assigned</p>
                        <span className="text-lg font-bold text-gray-800 flex items-center justify-center gap-2">
                            <span className="text-blue-500"><FaRegSmile /></span>
                            {serviceRequestData.vendorAssigned || 0}
                        </span>
                        <div className="text-xs text-gray-500 mt-1">
                            {serviceRequestData.total > 0
                                ? `${((serviceRequestData.vendorAssigned / serviceRequestData.total) * 100).toFixed(1)}%`
                                : '0%'
                            }
                        </div>
                    </div>
                </div>

                {/* Total Summary */}
                <div className="mt-4 p-3 bg-gray-50 rounded-lg">
                    <div className="text-center">
                        <p className="text-sm text-gray-600 mb-1">Total Service Requests</p>
                        <p className="text-2xl font-bold text-gray-800">{serviceRequestData.total}</p>
                        <p className="text-xs text-gray-500">
                            {activeButton.toLowerCase()} period � {roleId === 1000 ? 'All communities' : 'Your scope'}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceRequestRange;